export class CreatedBy {
    emp_firstname: string;
    emp_gender: number;
    emp_lastname: string;
    emp_middle_name: string;
    emp_nick_name: string;
    emp_number: number;
    emp_oth_email: string;
    emp_status: number;
    employee_id: string;
    job_title_code: number;
    joined_date: string;
    picture: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/created-by.ts